module.exports = __webpack_public_path__ + "assets/img/llh_pc.6458d5fb.jpg";